import type { ReactElement } from 'react'

import { avaliarForcaDaSenha } from '@/lib/forca-de-senha'
import { cn } from '@/lib/utils'

/**
 * Barra de progresso da força da senha.
 *
 * A cor NUNCA é a única informação — o rótulo em texto ("Fraca", "Excelente")
 * anda junto, e é ele que o leitor de tela anuncia. O amarelo da marca não
 * aparece aqui: neste contexto ele seria lido como "atenção", e amarelo é
 * identidade, não alerta.
 */

const CORES = ['bg-danger', 'bg-danger', 'bg-warning', 'bg-success', 'bg-success'] as const

export interface MedidorDeForcaDeSenhaProps {
  readonly senha: string
  readonly className?: string
}

export function MedidorDeForcaDeSenha({
  senha,
  className,
}: MedidorDeForcaDeSenhaProps): ReactElement | null {
  if (senha.length === 0) {
    return null
  }

  const { pontuacao, rotulo, dica } = avaliarForcaDaSenha(senha)
  const segmentos = [0, 1, 2, 3]

  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex gap-1" aria-hidden="true">
        {segmentos.map((indice) => (
          <span
            key={indice}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors',
              indice < pontuacao ? CORES[pontuacao] : 'bg-elevated',
            )}
          />
        ))}
      </div>

      <p className="text-xs text-fg-secondary" aria-live="polite">
        Força da senha: <span className="font-medium text-foreground">{rotulo}</span>
        {dica.length > 0 ? <span className="text-fg-muted"> · {dica}</span> : null}
      </p>
    </div>
  )
}
